import { render, staticRenderFns } from "./DropdownSelect2.vue?vue&type=template&id=5af23438&scoped=true&"
import script from "./DropdownSelect2.vue?vue&type=script&lang=js&"
export * from "./DropdownSelect2.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSelect2.vue?vue&type=style&index=0&id=5af23438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af23438",
  null
  
)

export default component.exports